import React from "react";
import ProfileCore from "../../shared/profile/ProfileCore";
import ProviderProfile from "../../components/Profile/ProviderProfile";

export default function ProfileProvider() {
    return (
        <ProfileCore
            renderContent={(profileData, refreshProfile) => (
                <ProviderProfile data={profileData} refreshProfile={refreshProfile} />
            )}
        />
    );
}
